export default class ChatBotConfigMessengerModel {
  constructor({
    id = 0,
    identificadorPagina = '',
    tokenAcessoPagina = '',
  } = {}) {
    this.id = id
    this.identificadorPagina = identificadorPagina
    this.tokenAcessoPagina = tokenAcessoPagina
  }
}
